import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Lock, Eye, EyeOff } from 'lucide-react';
import toast from 'react-hot-toast';

const QuotePasswordGate = ({ onUnlock, customerCity, customPassword, viewHash }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [attempts, setAttempts] = useState(0);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // PLZ aus Stadt extrahieren (z.B. "10117 Berlin" → "10117")
    const plzMatch = customerCity?.match(/^(\d{5})/);
    const expectedPLZ = plzMatch ? plzMatch[1] : null;
    
    // Validierung: Custom Password ODER PLZ
    const isValid = (customPassword && password === customPassword) || (expectedPLZ && password === expectedPLZ);
    
    if (isValid) {
      sessionStorage.setItem(`quote_access_${viewHash}`, 'granted');
      onUnlock(true);
      toast.success('Zugang gewährt');
    } else {
      setAttempts(prev => prev + 1);
      toast.error('Falsches Passwort');
      setPassword('');
      
      if (attempts >= 2) {
        toast.error('Zu viele Fehlversuche. Bitte kontaktieren Sie den Anbieter.');
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4">
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
            <Lock className="w-8 h-8 text-blue-600" />
          </div>
          <CardTitle className="text-2xl">Geschütztes Angebot</CardTitle>
          <p className="text-slate-600 text-sm mt-2">
            Dieses Angebot ist passwortgeschützt.
          </p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-sm font-medium text-slate-700 mb-2 block">
                Passwort
              </label>
              <div className="relative">
                <Input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Passwort eingeben"
                  className="pr-10"
                  autoFocus
                  disabled={attempts >= 3}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            
            {attempts > 0 && (
              <p className="text-sm text-red-600">
                Falsches Passwort ({attempts}/3 Versuche)
              </p>
            )}
            
            <Button 
              type="submit" 
              className="w-full"
              disabled={!password || attempts >= 3}
            >
              Zugang anfordern
            </Button>
            
            <p className="text-xs text-slate-500 text-center mt-4">
              Das Passwort haben Sie per E-Mail erhalten.
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default QuotePasswordGate;
